import { useModelService } from 'services/model/model.service';
import { customKpi, measureKpi, InfoDrawerKpiEntry } from 'components/InfoDrawer/InfoDrawerKpiEntry';
import { InfoDrawerKpis } from 'components/InfoDrawer/InfoDrawerKpis';
import { InfoContentItem } from 'components/InfoDrawer/InfoContentItem';

function useMarketplaceTabKpis(): InfoDrawerKpiEntry[] {
  const { getMeasures } = useModelService();

  const [ordGmvVal, retQtyRate, slsPrdNum, slsQty] = getMeasures([
    'ordGmvVal',
    'retQtyRateExpOD',
    'slsPrdNumOD',
    'slsQtyOD',
  ]);

  return [
    customKpi('active_marketplaces', {
      titleId: 'insights.marketplace_tab.active_marketplaces_header',
      descriptionId: 'insights.marketplace_tab.active_marketplaces_description',
    }),
    measureKpi(ordGmvVal),
    measureKpi(retQtyRate),
    customKpi('avgSoldItemsPerProduct', {
      titleId: 'model.calculated.metric.avgSoldItemsPerProduct.name',
      descriptionId: 'model.calculated.metric.avgSoldItemsPerProduct.description',
    }),
    measureKpi(slsPrdNum),
    measureKpi(slsQty),
  ];
}

export function MarketplaceTabInfoContent() {
  const kpis = useMarketplaceTabKpis();

  return (
    <InfoDrawerKpis.Default
      kpis={kpis}
      whyUsefulDescriptionId="insights.marketplace_tab.info.content.why_is_this_view_useful_description"
      showOrderBasedNote
    >
      <hr className="my-4 border-snow-200" />
      <InfoContentItem
        titleId="info.content.data_availability"
        descriptionId="info.content.data_availability.description"
      />
    </InfoDrawerKpis.Default>
  );
}
